import { render, staticRenderFns } from "./ProjectSiteDailyProgressNew.vue?vue&type=template&id=2bf2148e"
import script from "./ProjectSiteDailyProgressNew.vue?vue&type=script&lang=js"
export * from "./ProjectSiteDailyProgressNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports